import React, { Fragment } from "react";
import styled from "styled-components";

import PropTypes from "prop-types";
import { Button as ReButton, Flex, Heading } from "rebass";
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Divider,
  Portal,
  Sidebar,
} from "reakit";
import { Circle } from "styled-spinkit";

import placeholder from "../../resources/img/placeholder.png";
import { NavLink as Link } from "../Base";
import WavePopup from "../WavePopup";
import SignOutButton from "../Header/SignOutButton";
import ConfirmSetPanic from "../Modals/ConfirmSetPanic";
import MobileConfirmLocationPermission from "../Modals/MobileConfirmLocationPermission";

const linkProps = {
  color: "black",
  display: "block",
};

const StyledSidebar = styled(Sidebar)`
  width: 75vw;
`;

const StyledButton = styled(Button)`
  //border-radius: 23.5px;
  box-shadow: none;
  //width: 187px;
  z-index: 100;
  margin-left: 24px;
  margin-top: 24px;
  // height: 47px;
  overflow: hidden;
  background-color: transparent;
`;

/**
const StyledLink = styled.a`
 text-decoration: none;
`
*/

const SidebarMenu = (props) => {
  const {
    isFaculty,
    profile,
    school,
    loading,
    hideSidebar,
    toggleConfirmPanicPopup,
    permissionPopupVisible,
    popupPermissionPopupToggle,
    handlePermissionConfirm,
    handlePressPanic,
  } = props;

  // const { is_panic, hideSidebar } = this.state;
  let showCheckin = false;
  if (!loading) {
    if (isFaculty) {
      showCheckin = true;
    } else {
      if (profile && profile.is_prefect) {
        showCheckin = true;
      }
    }
  }
  return (
    <>
      {!hideSidebar && (
        <Sidebar.Container>
          {(sidebar) => (
            <Box>
              <StyledButton
                palette="transparent"
                opaque
                tone={0}
                use={Sidebar.Show}
                {...sidebar}
              >
                <Avatar
                  backgroundColor={"gray"}
                  src={profile ? profile.profile_pic : placeholder}
                  height={"25px"}
                  width={"25px"}
                />
              </StyledButton>

              <Backdrop fade use={[Portal, Sidebar.Hide]} {...sidebar} />
              <StyledSidebar use={Portal} slide {...sidebar}>
                {profile === null ? (
                  <Circle />
                ) : (
                  <Box>
                    <Flex justifyContent="center">
                      <Avatar
                        marginTop={"20px"}
                        src={profile ? profile.profile_pic : placeholder}
                        backgroundColor={"gray"}
                        fontSize={50}
                      />
                    </Flex>
                    <Flex justifyContent="center">
                      <Heading pt={3}>
                        {profile
                          ? profile.first_name + " " + profile.last_name
                          : ""}
                      </Heading>
                    </Flex>
                    <Flex justifyContent="center">
                      {isFaculty ? (
                        <Link to="/app/search">
                          <ReButton variant="main">Search</ReButton>{" "}
                        </Link>
                      ) : (
                        <WavePopup
                          isFaculty={isFaculty}
                          student={profile}
                          profile={profile}
                          school={school}
                        />
                      )}
                    </Flex>
                  </Box>
                )}
                <Link {...linkProps} className="nav-link" to="/app/profile">
                  My Profile
                </Link>
                <Link {...linkProps} color="black" to="/app/posts">
                  My Posts
                </Link>
                {/* <Link {...linkProps} color="black" to="/app/health">
                  My Health
                </Link>
                {profile.is_health_admin && (
                  <Link {...linkProps} color="black" to="/app/health-admin">
                    Health (Admin)
                  </Link>
                )} */}
                {/* {isFaculty ?
								<Link {...linkProps} color='black' to="/app/roster">
									My Rosters
								</Link> :
								<Fragment>
									{profile && profile.is_prefect === true &&
									<Link {...linkProps} color='black' to="/app/dorm">
										My Dorm
									</Link>}
								</Fragment>
							} */}

                {!isFaculty && (
                  <Fragment>
                    {profile && profile.is_prefect === true && (
                      <Link {...linkProps} color="black" to="/app/dorm">
                        My Dorm
                      </Link>
                    )}
                  </Fragment>
                )}
                {showCheckin && (
                  <Link {...linkProps} color="black" to="/app/checkin">
                    Check In
                  </Link>
                )}
                {/* <Divider margin={"0"} /> */}

                {/* <Link {...linkProps} color="black" to="/app/calendar">
                  Calendar
                </Link> */}

                {/* <Divider padding={"0"} margin={"0"} /> */}

                <Link {...linkProps} color="black" to="/app/search-faculty">
                  Search Faculty
                </Link>

                <Divider padding={"0"} margin={"0"} />
                <SignOutButton textAlign="center" />
                <Flex justifyContent={"center"} pt={1}>
                  {/* 	is_panic ?
											<ReButton onClick={handlePanicEvent} variant='main' bg='#2BB99E'>Cancel Panic</ReButton>
											:
											<ReButton onClick={toggleConfirmPanicPopup} variant='main' bg='red'>Panic Button</ReButton> */}
                  {/*
									<StyledLink href={`tel:${security_phone}`}>
										<ReButton onClick={handlePanicEvent} variant='main' bg='red'>Panic Button</ReButton>
									</StyledLink>
									*/}
                </Flex>
              </StyledSidebar>
            </Box>
          )}
        </Sidebar.Container>
      )}
      <ConfirmSetPanic
        visible={hideSidebar}
        toggle={toggleConfirmPanicPopup}
        handleConfirm={handlePressPanic}
      />
      <MobileConfirmLocationPermission
        visible={permissionPopupVisible}
        toggle={popupPermissionPopupToggle}
        handleConfirm={handlePermissionConfirm}
      />
    </>
  );
};

SidebarMenu.propTypes = {
  isFaculty: PropTypes.bool,
  toggleConfirmPanicPopup: PropTypes.func,
  handlePanicEvent: PropTypes.func,
};

SidebarMenu.defaultProps = {
  isFaculty: false,
};

export default SidebarMenu;
